module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Align-auto-0e4931dc611216a39574f0d49113b25f.svg";